module.exports = __webpack_public_path__ + "img/warry.fff4934c.png";